import type { HelpFile } from '../../types/help'
import { RestrictionRuleDetailTestIds } from '../../../testids/RestrictionRuleDetailTestIds'

export const restrictionRuleDetailHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleDetailTestIds.restrictionRuleDetailPage]:
      'Restriktionsregel im Detail — Konfiguration, verbotene Zugriffsprofile, Status und aktuelle Verstöße.',
    [RestrictionRuleDetailTestIds.cardRuleDetails]:
      'Grundkonfiguration: Eigentümer, Status, Bedingungsausdruck und Karenzzeit.',
    [RestrictionRuleDetailTestIds.ruleInfoCard]: null,
    [RestrictionRuleDetailTestIds.sectionConditionExpression]:
      'Optionaler CEL-Ausdruck, der die Regel auf eine Teilmenge von Identitäten begrenzt — nicht passende Identitäten werden nicht ausgewertet.',
    [RestrictionRuleDetailTestIds.sectionDeniedProfiles]:
      'Zusammen verbotene Zugriffsprofile — wer alle aufgeführten Profile hält, verstößt gegen die Regel.',
    [RestrictionRuleDetailTestIds.ruleConditionExpr]:
      'Bedingungsausdruck — gilt die Regel nur für Identitäten, die dem CEL-Ausdruck entsprechen.',
    [RestrictionRuleDetailTestIds.ruleGraceDays]:
      'Karenzzeit in Tagen — neu erkannte Verstöße können innerhalb dieser Frist behoben werden.',
    [RestrictionRuleDetailTestIds.ruleStatus]:
      'Aktivierungsstatus — aktive Regeln werden fortlaufend ausgewertet.',
    [RestrictionRuleDetailTestIds.badgeActive]: null,
    [RestrictionRuleDetailTestIds.badgeInactive]: null,
    [RestrictionRuleDetailTestIds.badgeViolations]:
      'Gesamtzahl der gegen diese Regel erfassten Verstöße.',
    [RestrictionRuleDetailTestIds.badgeOpenViolations]:
      'Noch offene, nicht behobene Verstöße.',
    [RestrictionRuleDetailTestIds.btnEdit]:
      'Änderungsassistenten öffnen, um Anpassungen an dieser Restriktionsregel vorzuschlagen.',
    [RestrictionRuleDetailTestIds.btnTestRestrictionRule]:
      'Regel gegen aktuelle Identitätsdaten ausführen — zeigt ausgewertete Identitäten, Treffer und offene Verstöße.',
    [RestrictionRuleDetailTestIds.btnActivate]:
      'Aktivierungsantrag für diese Regel im Genehmigungsworkflow einreichen.',
    [RestrictionRuleDetailTestIds.btnDeactivate]:
      'Deaktivierungsantrag für diese Regel im Genehmigungsworkflow einreichen.',
    [RestrictionRuleDetailTestIds.dialogActivateRule]:
      'Bestätigung vor dem Einreichen des Aktivierungsantrags im Genehmigungsworkflow.',
    [RestrictionRuleDetailTestIds.dialogDeactivateRule]:
      'Bestätigung vor dem Einreichen des Deaktivierungsantrags im Genehmigungsworkflow.',
    [RestrictionRuleDetailTestIds.openRequestBanner]:
      'Für diese Regel steht derzeit ein Änderungsantrag aus.',
    [RestrictionRuleDetailTestIds.linkOpenRequest]:
      'Ausstehenden Änderungsantrag für diese Regel öffnen.',
    [RestrictionRuleDetailTestIds.linkViolations]:
      'Verstöße gefiltert nach dieser Regel anzeigen.',
    [RestrictionRuleDetailTestIds.colProfileCode]:
      'Code des verbotenen Zugriffsprofils.',
    [RestrictionRuleDetailTestIds.colProfileName]: null,
    [RestrictionRuleDetailTestIds.colResource]:
      'Ressource, auf die das verbotene Zugriffsprofil angewendet wird.',
    [RestrictionRuleDetailTestIds.colSystem]:
      'Zielsystem, auf das das verbotene Zugriffsprofil angewendet wird.',
  },
}
